import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { transpileModule } from 'typescript';
import { SubscriptionForm } from '../SubscriptionForm/SubscriptionForm';
@Component
export class DropdownButton extends ThemeComponent {
    @Ref() navButton!: HTMLButtonElement;

    private childClickedEvent!: Event;
    private childButtons!: NodeListOf<HTMLButtonElement>;
    private subscriptionForm: SubscriptionForm|null;

    private _onDropDownSelect = new SimpleEvent<string>();
    public get onDropDownSelect() {
        return this._onDropDownSelect.asEvent();
    }

    constructor() {
        super();
        this.childClickedEvent = new Event('dropdown-button-click');
        this.childButtons = this.querySelectorAll('.dropdown__child-button');
        this.subscriptionForm = null;
    }

    init() {

        const stickyFooter = this.closest('.product-sticky-footer');
        if (stickyFooter) {
            const subscriptionForm =
            document.querySelector('subscription-form') as SubscriptionForm;

            if (subscriptionForm) {
                this.$subscribe(subscriptionForm.onProductChange, (frequency: string) => {
                    const buttonToSelect = this.querySelector(`[data-linked-input="${frequency}"]`);
                    if (buttonToSelect) {
                        this.switchButton(buttonToSelect as HTMLButtonElement);
                    }
                });
            }
        }

        this.$listen(this, 'mouseover', (event) => {
            const targetElement = event.target as HTMLElement;
            // If this dropdown button was hovered, open it
            // otherwise, close it
            if (targetElement.closest('.dropdown-button') == this &&
                !this.classList.contains('dropdown-button--active')) {
                this.openDropdown();
            }
        });

        this.$listen(this, 'mouseout', (event) => {

            // If this dropdown button was hovered, open it
            // otherwise, close it

            this.closeDropdown();

        });

        // Listen for click events on the window
        this.$listen(window, 'click', (event) => {
            // If the target element is within a dropdown wrapper
            // select the clicked element and bail
            const targetElement = event.target as HTMLElement;
            const dropdown = targetElement.closest('dropdown-button');
            const dropdownWrapper = targetElement.closest('.dropdown-button__dropdown-wrapper');

            if (dropdown == this && dropdownWrapper) {
                if (targetElement.closest('.dropdown__child-button')) {

                    const clickedButton = targetElement.closest('.dropdown__child-button');
                    const subscriptionForm =
                    document.querySelector('subscription-form') as SubscriptionForm;

                    if (subscriptionForm && clickedButton) {
                        const frequency = clickedButton.getAttribute('data-linked-input');
                        if (frequency) {
                            subscriptionForm.updateSelectedFrequency(frequency);
                        }
                    }

                    if (clickedButton) {
                        this.switchButton(clickedButton as HTMLButtonElement);
                    }

                    this.dispatchEvent(this.childClickedEvent);

                }

            }

            // If this dropdown button was clicked, open it
            // otherwise, close it
            if (targetElement.closest('.dropdown-button') == this &&
                !this.classList.contains('dropdown-button--active')) {
                this.openDropdown();
            } else {
                this.closeDropdown();
            }

        });
    }

    openDropdown() {
        this.classList.add('dropdown-button--active');
        this.dispatchEvent(new Event('DropdownActive', {
            bubbles: true
        }));
    }

    closeDropdown() {
        this.classList.remove('dropdown-button--active');
        this.dispatchEvent(new Event('DropdownInactive', {
            bubbles: true
        }));
    }

    switchButton(clickedButton: HTMLButtonElement) {
        // Switch the selected button to the one that was clicked
        for (const button of this.childButtons) {
            button.classList.remove('button--selection-active');
        }
        clickedButton.classList.add('button--selection-active');

        // Switch the content in the dropdown trigger element to
        // the content of the selected option
        const selectChangeParent = clickedButton.getAttribute('data-select-parent');
        const selectChangeParentElement = document.querySelector(`${selectChangeParent}`) ||
            this.navButton as HTMLElement;
        const selectChangeData = clickedButton.getAttribute('data-select-text');
        if (selectChangeData) {
            const selectChangeDataJson = JSON.parse(selectChangeData);
            for (const object of selectChangeDataJson) {
                const elementToChange =
                    selectChangeParentElement.querySelector(`.${object.selector}`) as HTMLElement;
                if (elementToChange) {
                    elementToChange.innerText = object.text as string;
                }
            }
        }

    }
}
